import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import { createElement } from 'react';

const rootRouteRef = createRouteRef({ id: 'catalog-landing' });

const CatalogLandingPage = PageBlueprint.make({
  params: {
    path: '/system',
    routeRef: rootRouteRef,
    title: 'Systems',
    loader: async () => {
      const { CatalogLanding } = await import(
        './components/CatalogLanding/CatalogLanding'
      );
      return createElement(CatalogLanding);
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'catalog-landing',
  extensions: [CatalogLandingPage],
  routes: {
    root: rootRouteRef,
  },
});
